/*
 * @Descripttion: 
 * @version: 
 * @Author: wangz
 * @Date: 2019-11-21 14:58:03
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-02 10:59:13
 */

import { GUID } from "../sgiConstants/sgiCommonConstant"
import sgiAntdModule from "../sgiConstants/sgiAntdModule";
import React from 'react'
import md5Fun from './MD5'
import JSZip from 'jszip'
import CryptoJS from 'crypto-js'
import { Modal } from "antd";
import { sgiLogger } from './sgiLogger';

let sgiEncrypt = {
	aseKey: "12345678",    //秘钥必须为：8/16/32位
	//加密 DES/AES切换只需要修改 CryptoJS.AES <=> CryptoJS.DES
	encrypt: function (message) {
		if (!message) return message;
		return CryptoJS.AES.encrypt(message + "", CryptoJS.enc.Utf8.parse(this.aseKey), {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7
		}).toString();
	},
	//解密
	decrypt: function (encryptMessage) {
		if (!encryptMessage) return encryptMessage;
		return CryptoJS.AES.decrypt(encryptMessage, CryptoJS.enc.Utf8.parse(this.aseKey), {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7
		}).toString(CryptoJS.enc.Utf8);
	}
}

/**
 * 平台提供压缩方法
 */
var sgiZip = {

	zip: function (key, value) {
		try {
			var zip = new JSZip();
			zip.file(key, value);
			return zip.generate({
				'compression': 'DEFLATE',
				type: "string"
			});
		} catch (error) {
			sgiLogger.log(error)
		}

	},
	unzip: function (key, value) {
		try {
			var zip = new JSZip();
			zip.load(value);
			return zip.file(key).asText();
		} catch (error) {
			sgiLogger.log(error);
		}
	}
}

/**
 * 用浏览器内部转换器实现html转码
 * @namespace html转码器
 * @alias tool.HtmlUtil
 */
var HtmlUtil = {
	/**
	 * 1、用浏览器内部转换器实现html转码
	 * @param {*} html 
	 * @returns {*}
	 */
	htmlEncode: function (html) {
		//1.首先动态创建一个容器标签元素，如DIV
		var temp = document.createElement("div");
		//2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(火狐，google支持)
		(temp.textContent != undefined) ? (temp.textContent = html) : (temp.innerText = html);
		//3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
		var output = temp.innerHTML;
		temp = null;
		return output;
	},
	/**
	 * 2、用浏览器内部转换器实现html解码
	 * @param {*} text 
	 * @returns {*} 
	 */
	htmlDecode: function (text) {
		//1.首先动态创建一个容器标签元素，如DIV
		var temp = document.createElement("div");
		//2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
		temp.innerHTML = text;
		//3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
		var output = temp.innerText || temp.textContent;
		temp = null;
		return output;
	}
};

/**
 * 指定长度和进制的UUID
 * @param {number} [len] 长度
 * @param {number} [radix] 进制，2,8,10,16
 * @returns {string} id
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function uuid(len, radix) {
	var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	var uuid = [],
		i;
	radix = radix || chars.length;

	if (len) {
		// Compact form
		for (i = 0; i < len; i++)
			uuid[i] = chars[0 | Math.random() * radix];
	}
	else {
		// rfc4122, version 4 form
		var r;

		// rfc4122 requires these characters
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';

		// Fill in random data. At i==19 set the high bits of clock sequence as per
		// rfc4122, sec. 4.1.5
		for (i = 0; i < 36; i++) {
			if (!uuid[i]) {
				r = 0 | Math.random() * 16;
				uuid[i] = chars[(i == 19)
					? (r & 0x3) | 0x8
					: r];
			}
		}
	}

	return uuid.join('');
}

/**
 * 包装React.createElement，动态创建组件
 * @param {string} tag element标签，支持html原生（例："div"）、antd（以antd_开始，例："antd_Input"）、自定义组件
 * @param {object} [attr] 属性对象
 * @param {element|element[]} [children] 子组件/子组件数组
 * @param {boolean} [customeFlag=false] 自定义组件标识
 * @returns {element} 动态生成的元素实例
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function createElement(tag, attr, children, customeFlag) {

	if (!tag) return;

	if (typeof tag === "string" && (tag.substr(0, 5) === "antd_" || tag.substr(0, 5) === "antd-")) {// antd组件
		tag = sgiAntdModule[tag.substring(5)];
		if (!tag) return;

	} else if (customeFlag) {// 自定义组件
		tag = sgiCustomModule[tag];
		if (!tag) return;

	}

	if (attr) attr.ref = refFunction;

	return React.createElement(tag, attr, children);
}

/**
 * 生成uuid，当前时间+指定长度的随机数，默认：6位
 * @param {number} len 长度
 * @param {string} [format="yyyyMMddhhmmss"] 格式化，默认"yyyyMMddhhmmss"
 * @returns {string} 生成的uuid
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function uuidDate(len, format) {
	var date = new Date();
	var strD = date.format(format || "yyyyMMddhhmmss");
	var Num = "";
	if (!len && len !== 0) {
		len = 6;
	}
	for (var i = 0; i < len; i++) {
		Num += Math.floor(Math.random() * 10);
	}
	return strD + Num;
}

/**
 * 添加部分日期操作方法
 * @namespace 日期追加方法集
 * @alias Date
 */

/**
 * 日期格式化format，格式化样式例如："yyyy-MM-dd hh:mm:ss:SSS"
 * @param {string} fmt 格式化
 * @returns {string} 格式化后的日期字符串
 */
Date.prototype.format = function (fmt) {
	var o = {
		"M+": this.getMonth() + 1, //月份
		"d+": this.getDate(), //日
		"h+": this.getHours(), //小时
		"m+": this.getMinutes(), //分
		"s+": this.getSeconds(), //秒
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度
		"S+": this.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
		// if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("000" + o[k]).substr(-RegExp.$1.length)));
	return fmt;
}


/**
 * 把日期分割成数组,返回数组：[getFullYear(),getMonth(),getDate(),getHours(),getMinutes(),getSeconds()]
 * @returns {array} [getFullYear(),getMonth(),getDate(),getHours(),getMinutes(),getSeconds()]
 */
//+--------------------------------------------------- 
//| 把日期分割成数组 
//+--------------------------------------------------- 
Date.prototype.toArray = function () {
	var myDate = this;
	var myArray = Array();
	myArray[0] = myDate.getFullYear();
	myArray[1] = myDate.getMonth();
	myArray[2] = myDate.getDate();
	myArray[3] = myDate.getHours();
	myArray[4] = myDate.getMinutes();
	myArray[5] = myDate.getSeconds();
	return myArray;
}

/**
 * 取得日期数据信息 
 * 参数 interval 表示数据类型
 * y年 m月 d日 w星期 ww周 h时 n分 s秒 
 * @param {y|m|d|w|ww|h|n|s} interval 获取信息类型
 * @returns {any} 对应信息
 */
//+--------------------------------------------------- 
//| 取得日期数据信息 
//| 参数 interval 表示数据类型 
//| y 年 m月 d日 w星期 ww周 h时 n分 s秒 
//+--------------------------------------------------- 
Date.prototype.DatePart = function (interval) {
	var myDate = this;
	var partStr = '';
	var Week = ['日', '一', '二', '三', '四', '五', '六'];
	switch (interval) {
		case 'y': partStr = myDate.getFullYear(); break;
		case 'm': partStr = myDate.getMonth() + 1; break;
		case 'd': partStr = myDate.getDate(); break;
		case 'w': partStr = Week[myDate.getDay()]; break;
		case 'ww': partStr = myDate.WeekNumOfYear(); break;
		case 'h': partStr = myDate.getHours(); break;
		case 'n': partStr = myDate.getMinutes(); break;
		case 's': partStr = myDate.getSeconds(); break;
	}
	return partStr;
}

/**
 * 取得当前日期所在月的最大天数
 * @returns {*} 最大天数
 */
//+--------------------------------------------------- 
//| 取得当前日期所在月的最大天数 
//+--------------------------------------------------- 
Date.prototype.MaxDayOfDate = function () {
	var myDate = this;
	var ary = myDate.toArray();
	var date1 = (new Date(ary[0], ary[1] + 1, 1));
	var date2 = date1.dateAdd(1, 'm', 1);
	var result = dateDiff(date1.Format('yyyy-MM-dd'), date2.Format('yyyy-MM-dd'));
	return result;
}

/**
 * 判断闰年
 * @returns {boolean} 是否是闰年
 */
//--------------------------------------------------- 
// 判断闰年 
//--------------------------------------------------- 
Date.prototype.isLeapYear = function () {
	return (0 == this.getYear() % 4 && ((this.getYear() % 100 != 0) || (this.getYear() % 400 == 0)));
}

/**
 * 日期格式化Format
 * 格式 YYYY/yyyy/YY/yy 表示年份 
 * MM/M 月份 
 * W/w 星期 
 * dd/DD/d/D 日期 
 * hh/HH/h/H 时间 
 * mm/m 分钟 
 * ss/SS/s/S 秒 
 * @param {string} formatStr 格式化
 * @returns {string} 格式化后的日期字符串
 */
//--------------------------------------------------- 
// 日期格式化 
// 格式 YYYY/yyyy/YY/yy 表示年份 
// MM/M 月份 
// W/w 星期 
// dd/DD/d/D 日期 
// hh/HH/h/H 时间 
// mm/m 分钟 
// ss/SS/s/S 秒 
//--------------------------------------------------- 
Date.prototype.Format = function (formatStr) {
	var str = formatStr;
	var Week = ['日', '一', '二', '三', '四', '五', '六'];

	str = str.replace(/yyyy|YYYY/, this.getFullYear());
	str = str.replace(/yy|YY/, (this.getYear() % 100) > 9 ? (this.getYear() % 100).toString() : '0' + (this.getYear() % 100));

	str = str.replace(/MM/, this.getMonth() > 9 ? this.getMonth().toString() : '0' + this.getMonth());
	str = str.replace(/M/g, this.getMonth());

	str = str.replace(/w|W/g, Week[this.getDay()]);

	str = str.replace(/dd|DD/, this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate());
	str = str.replace(/d|D/g, this.getDate());

	str = str.replace(/hh|HH/, this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours());
	str = str.replace(/h|H/g, this.getHours());
	str = str.replace(/mm/, this.getMinutes() > 9 ? this.getMinutes().toString() : '0' + this.getMinutes());
	str = str.replace(/m/g, this.getMinutes());

	str = str.replace(/ss|SS/, this.getSeconds() > 9 ? this.getSeconds().toString() : '0' + this.getSeconds());
	str = str.replace(/s|S/g, this.getSeconds());

	return str;
}

/**
 * 日期计算：s-秒，n-分，h-小时，d-天，w-周，q-季度，m-月，y-年
 * @param {s|n|h|d|w|q|m|y} strInterval 计算类型
 * @param {number} Number 加多少，可为负数，代表减
 * @returns {Date} 计算后的date
 */
//+--------------------------------------------------- 
//| 日期计算 
//+--------------------------------------------------- 
Date.prototype.DateAdd = function (strInterval, Number) {
	var dtTmp = this;
	switch (strInterval) {
		case 's': return new Date(Date.parse(dtTmp) + (1000 * Number));
		case 'n': return new Date(Date.parse(dtTmp) + (60000 * Number));
		case 'h': return new Date(Date.parse(dtTmp) + (3600000 * Number));
		case 'd': return new Date(Date.parse(dtTmp) + (86400000 * Number));
		case 'w': return new Date(Date.parse(dtTmp) + ((86400000 * 7) * Number));
		case 'q': return new Date(dtTmp.getFullYear(), (dtTmp.getMonth()) + Number * 3, dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds());
		case 'm': return new Date(dtTmp.getFullYear(), (dtTmp.getMonth()) + Number, dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds());
		case 'y': return new Date((dtTmp.getFullYear() + Number), dtTmp.getMonth(), dtTmp.getDate(), dtTmp.getHours(), dtTmp.getMinutes(), dtTmp.getSeconds());
	}
}

/**
 * 比较日期差 dtEnd 格式为日期型或者 有效日期格式字符串 
 * @param {s|n|h|d|w|m|y} strInterval 比对类型
 * @param {string|Date} dtEnd 格式为日期型或者 有效日期格式字符串
 */
//+--------------------------------------------------- 
//| 比较日期差 dtEnd 格式为日期型或者 有效日期格式字符串 
//+--------------------------------------------------- 
Date.prototype.DateDiff = function (strInterval, dtEnd) {
	var dtStart = this;
	if (typeof dtEnd == 'string')//如果是字符串转换为日期型 
	{
		dtEnd = StringToDate(dtEnd);
	}
	switch (strInterval) {
		case 's': return parseInt((dtEnd - dtStart) / 1000);
		case 'n': return parseInt((dtEnd - dtStart) / 60000);
		case 'h': return parseInt((dtEnd - dtStart) / 3600000);
		case 'd': return parseInt((dtEnd - dtStart) / 86400000);
		case 'w': return parseInt((dtEnd - dtStart) / (86400000 * 7));
		case 'm': return (dtEnd.getMonth() + 1) + ((dtEnd.getFullYear() - dtStart.getFullYear()) * 12) - (dtStart.getMonth() + 1);
		case 'y': return dtEnd.getFullYear() - dtStart.getFullYear();
	}
}

/**
 * 日期输出字符串，重载了系统的toString方法
 * @param {boolean} showWeek 是否显示星期
 * @returns {string} 返回日期字符串
 */
//+--------------------------------------------------- 
//| 日期输出字符串，重载了系统的toString方法 
//+--------------------------------------------------- 
Date.prototype.toString = function (showWeek) {
	var myDate = this;
	var str = myDate.toLocaleDateString();
	if (showWeek) {
		var Week = ['日', '一', '二', '三', '四', '五', '六'];
		str += ' 星期' + Week[myDate.getDay()];
	}
	return str;
}


/**
 * 部分日期操作方法集
 * @namespace 日期操作方法集
 * @alias tool.DateOpt
 */
let DateOpt = {
	/**
	 * 求两个时间的天数差，日期格式为："YYYY-MM-dd"
	 * @param {string} DateOne 第一个日期
	 * @param {string} DateTwo 第二个日期
	 * @returns {*} 天数差
	 */
	//+--------------------------------------------------- 
	//| 求两个时间的天数差 日期格式为 YYYY-MM-dd 
	//+--------------------------------------------------- 
	daysBetween: function (DateOne, DateTwo) {
		var OneMonth = DateOne.substring(5, DateOne.lastIndexOf('-'));
		var OneDay = DateOne.substring(DateOne.length, DateOne.lastIndexOf('-') + 1);
		var OneYear = DateOne.substring(0, DateOne.indexOf('-'));

		var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf('-'));
		var TwoDay = DateTwo.substring(DateTwo.length, DateTwo.lastIndexOf('-') + 1);
		var TwoYear = DateTwo.substring(0, DateTwo.indexOf('-'));

		var cha = ((Date.parse(OneMonth + '/' + OneDay + '/' + OneYear) - Date.parse(TwoMonth + '/' + TwoDay + '/' + TwoYear)) / 86400000);
		return Math.abs(cha);
	},
	/**
	 * 日期合法性验证，格式为：YYYY-MM-DD或YYYY/MM/DD 
	 * @param {string} DateStr 日期字符串
	 * @returns {boolean} 是否合法
	 */
	//+--------------------------------------------------- 
	//| 日期合法性验证 
	//| 格式为：YYYY-MM-DD或YYYY/MM/DD 
	//+--------------------------------------------------- 
	IsValidDate: function (DateStr) {
		var sDate = DateStr.replace(/(^\s+|\s+$)/g, ''); //去两边空格; 
		if (sDate == '') return true;
		//如果格式满足YYYY-(/)MM-(/)DD或YYYY-(/)M-(/)DD或YYYY-(/)M-(/)D或YYYY-(/)MM-(/)D就替换为'' 
		//数据库中，合法日期可以是:YYYY-MM/DD(2003-3/21),数据库会自动转换为YYYY-MM-DD格式 
		var s = sDate.replace(/[\d]{ 4,4 }[\-/]{ 1 }[\d]{ 1,2 }[\-/]{ 1 }[\d]{ 1,2 }/g, '');
		if (s == '') //说明格式满足YYYY-MM-DD或YYYY-M-DD或YYYY-M-D或YYYY-MM-D 
		{
			var t = new Date(sDate.replace(/\-/g, '/'));
			var ar = sDate.split(/[-/:]/);
			if (ar[0] != t.getYear() || ar[1] != t.getMonth() + 1 || ar[2] != t.getDate()) {
				//alert('错误的日期格式！格式为：YYYY-MM-DD或YYYY/MM/DD。注意闰年。'); 
				return false;
			}
		}
		else {
			//alert('错误的日期格式！格式为：YYYY-MM-DD或YYYY/MM/DD。注意闰年。'); 
			return false;
		}
		return true;
	},
	/**
	 * 日期时间检查，格式为：YYYY-MM-DD HH:MM:SS 
	 * @param {string} str 日期字符串
	 * @returns {boolean} 是否符合
	 */
	//+--------------------------------------------------- 
	//| 日期时间检查 
	//| 格式为：YYYY-MM-DD HH:MM:SS 
	//+--------------------------------------------------- 
	CheckDateTime: function (str) {
		var reg = /^(\d+)-(\d{ 1,2 })-(\d{ 1,2 }) (\d{ 1,2 }):(\d{ 1,2 }):(\d{ 1,2 })$/;
		var r = str.match(reg);
		if (r == null) return false;
		r[2] = r[2] - 1;
		var d = new Date(r[1], r[2], r[3], r[4], r[5], r[6]);
		if (d.getFullYear() != r[1]) return false;
		if (d.getMonth() != r[2]) return false;
		if (d.getDate() != r[3]) return false;
		if (d.getHours() != r[4]) return false;
		if (d.getMinutes() != r[5]) return false;
		if (d.getSeconds() != r[6]) return false;
		return true;
	},

	/**
	 * 字符串转成日期类型，格式：MM/dd/YYYY、MM-dd-YYYY、YYYY/MM/dd、YYYY-MM-dd 
	 * @param {string} DateStr 日期字符串
	 * @returns {Date} 返回对应date
	 */
	//+--------------------------------------------------- 
	//| 字符串转成日期类型 
	//| 格式 MM/dd/YYYY MM-dd-YYYY YYYY/MM/dd YYYY-MM-dd 
	//+--------------------------------------------------- 
	StringToDate: function (DateStr) {

		var converted = Date.parse(DateStr);
		var myDate = new Date(converted);
		if (isNaN(myDate)) {
			//var delimCahar = DateStr.indexOf('/')!=-1?'/':'-'; 
			var arys = DateStr.split('-');
			myDate = new Date(arys[0], --arys[1], arys[2]);
		}
		return myDate;
	}
}


/**
 * 获取json对象长度
 * @param {object} jsonData json对象
 * @returns {number} 长度
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function getJsonLength(jsonData) {
	var length = 0;
	for (var ever in jsonData) {
		length++;
	}
	return length;
}

/**
 * 赋值数组
 * @param {array} arr 要复制的数组
 * @param {boolean} [flag=false] 是否深度赋值
 * @returns {array} 新的数组
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function copyArr(arr, flag) {
	let res = []
	for (let i = 0; i < arr.length; i++) {
		let tmp;
		if (flag) {
			tmp = copy(arr[i], true);
		} else {
			tmp = arr[i];
		}
		res.push(tmp);
	}
	return res;
}

/**
 * 拷贝 包括深浅拷贝
 * @param {object} obj 对象
 * @param {boolean} [flag=false] 是否深拷贝
 * @returns {object} 新的对象
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function copy(obj, flag) {
	if (flag) {
		return deepCopy(obj);
	}
	var newobj = {};
	for (var attr in obj) {
		if (attr != '_key') {
			newobj[attr] = obj[attr];
		}
	}
	return newobj;
}

/**
 * 获取对象类型
 * @param {any} obj js任意类型对象
 * @returns {boolean|number|string|function|array|date|regExp|undefined|null|object|element} 对象类型字符串
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function getType(obj) {
	//tostring会返回对应不同的标签的构造函数
	var toString = Object.prototype.toString;
	var map = {
		'[object Boolean]': 'boolean',
		'[object Number]': 'number',
		'[object String]': 'string',
		'[object Function]': 'function',
		'[object Array]': 'array',
		'[object Date]': 'date',
		'[object RegExp]': 'regExp',
		'[object Undefined]': 'undefined',
		'[object Null]': 'null',
		'[object Object]': 'object'
	};
	if (obj instanceof Element) {
		return 'element';
	}
	return map[toString.call(obj)];
}

/**
 * 深拷贝（去除_key属性）
 * @param {any} data 任意对象
 * @returns {any} 新的对象
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function deepCopy(data) {
	var type = getType(data);
	var obj;
	if (type === 'array') {
		obj = [];
	} else if (type === 'object') {
		obj = {};
	} else {
		//不再具有下一层次
		return data;
	}
	if (type === 'array') {
		for (var i = 0, len = data.length; i < len; i++) {
			obj.push(deepCopy(data[i]));
		}
	} else if (type === 'object') {
		for (var key in data) {
			if (key != '_key') {
				obj[key] = deepCopy(data[key]);
			}
		}
	}
	return obj;
}

/**
 * 深拷贝
 * @param {any} data 任意对象
 * @returns {any} 新的对象
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function deepCopyAll(data) {
	var type = getType(data);
	var obj;
	if (type === 'array') {
		obj = [];
	} else if (type === 'object') {
		obj = {};
	} else {
		//不再具有下一层次
		return data;
	}
	if (type === 'array') {
		for (var i = 0, len = data.length; i < len; i++) {
			obj.push(deepCopyAll(data[i]));
		}
	} else if (type === 'object') {
		for (var key in data) {
			obj[key] = deepCopyAll(data[key]);
		}
	}
	return obj;
}


/**
 * 判断字符串是否是json
 * @param {string} str 字符串
 * @returns {boolean} 是否是json
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function isJSON(str) {
	if (typeof str == 'string') {
		try {
			JSON.parse(str);
			return true;
		} catch (e) {
			// sgiLogger.log(e);
			return false;
		}
	}
	sgiLogger.log('It is not a string!')
}

/**
 * 拷贝对象（根据属性数组，浅拷贝）
 * @param {object} json 对象
 * @param {string[]} attrs 要拷贝的属性数组
 * @returns {object} 新的对象
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function copyJsonAttr(json, attrs) {
	if (!json) {
		return;
	}
	if (!attrs || attrs.length < 1) {
		return;
	}
	let newJson = {};
	attrs.forEach(element => {
		if (element) {
			newJson[element] = json[element]
		}

	});
	return newJson;
}

/**
 * 对象转字符串（函数也转）
 * @param {object} json 要转换的对象
 * @returns {string} 转换后的字符串
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function jsonToStr(json) {
	var retrunVal;
	if (typeof json === "object") {
		retrunVal = JSON.stringify(json);
		return retrunVal;
	}
	return json;
}

/**
 * 字符串转json
 * @param {string} str 要转换的字符串
 * @returns {object} 转换后的对象
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function strToJson(str) {
	// 校验
	if (str === undefined || str === "") return null;

	var json;
	if (typeof str != "object") {
		json = JSON.parse(str);
		return json;
	}
	return str;
}

/**
 * 校验字符串是否是有效函数字符串，去除注释、空格、空行后是否有有效函数体
 * @param {string} str 字符串
 * @returns {boolean} 是否有效
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function funStrCheck(str) {
	if (!str) return false;

	// 正则表达式
	let reg = /("([^\\\"]*(\\.)?)*")|('([^\\\']*(\\.)?)*')|(\/{2,}.*?(\r|\n))|(\/\*(\n|.)*?\*\/)/g;
	// 去除注释，去除空格和换行
	let newStr = str.replace(reg, (word) => (/^\/{2,}/.test(word) || /^\/\*/.test(word) ? "" : word)).replace(/[ |\r|\n]/g, "");
	return !!newStr;
}

/**
 * 获取guid字符串中的ap
 * @param {string} guid guid字符串
 * @returns {string} ap字符串
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function getAP(guid) {
	if (!guid) {
		return "";
	}
	var elems = getWords(guid, GUID.SP);
	if (!elems || elems.length != 4) {
		return "";
	}
	return elems[0];
}

/**
 * 根据指定的分隔符，将一个字符串分割为字符串数组 str -- 输入参数，需要分解的字符串 spt --
 * 输入参数，分隔符，允许多个，例如：',' 和 '.' 都是分隔符，spt = ",." 返回 字符串数组
 * @param {string} str 要分割的字符串
 * @param {string} spt 作为分隔的字符串
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function getWords(str, spt) {
	if (!str)
		return null;
	if (!spt)
		return [str];
	if (typeof str != 'string')
		return [];
	if (typeof spt != 'string')
		return [str];
	var sptExp = new RegExp("[" + spt + "]"); // 分隔符匹配正则表达式，separator
	// regular expression
	return str.split(sptExp);
}
/**
 * 从树结构的json中取得json数据的最底层
 * @param {object} treeJson 树json对象
 * @returns {object[]} 所有叶子节点/最底层数据数组
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
function getLeafByPrm(treeJson) {
	var array = [];
	if (!treeJson) {
		return array;
	}
	var sGuid = [];
	var fn = function (node, sGuid) {
		var children = node.cldSet;
		if (children) {
			children.forEach(c => {
				var cCld = c.cldSet;
				var sc = c.sc;
				sGuid.push(sc);
				if (cCld) {
					fn(c, sGuid);
				} else {
					c.sc = sGuid.join("`");
					array.push(c);
				}
				sGuid.pop(sc);
			});
		}
	}
	fn(treeJson, sGuid);
	return array;
}

// 根据parm的json对象转化成获得treeModel对象
// function cvtTreeByPrm(data) {
// 	if (!data) {
// 		return new Ext.data.TreeModel();
// 	}
// 	// 取得该数据的描述
// 	var guid = data.desId;
// 	// var eod = Ep.PrmFactory.getPrmJson(guid);
// 	// if (!eod) {
// 	// return new Ext.data.TreeModel();
// 	// }
// 	// 定义该类，创建该类对象
// 	var cNClass = this.defineTMByEod(guid);
// 	if (!cNClass) {
// 		return new Ext.data.TreeModel();
// 	}
// 	var root = this.createTreeObj(cNClass, data);
// 	this.addChilds(root, data.cldSet);
// 	// 删除root中的cldSet属性,该属性只是后面创建节点信息，不属于本身信息
// 	delete root.data.cldSet;
// 	return root;
// }

/**
 * 计算md5值
 * @param {any} info 任意对象
 * @returns {string} md5值
 * 
 * @memberof tool
 * @function
 * @group _global_
 */
let md5 = function (info) {
	if (typeof info == 'string') {
		return md5Fun(info)
	} else {
		return md5Fun(jsonToStr(info))
	}
}

/**
 * 
 * @param {*} target 
 * @ignore
 */
let assignProps = function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];
		// 遍历一个对象的自身和继承来的属性，
		// 常常配合hasOwnProperty筛选出对象自身的属性
		for (var key in source) {
			if (key === "style" && target[key]) {
				target[key] = assignProps(target[key], source[key]);
			} else {
				target[key] = source[key];
			}
			// // 使用call方法,避免原型对象扩展带来的干扰
			// if (Object.prototype.hasOwnProperty.call(source, key)) {
			// 	target[key] = source[key];
			// }
		}
	}
	return target;
}
/**
 * 
 * @param {*} target 
 * @ignore
 */
let assignPropsNotUndefined = function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];
		for (var key in source) {
			if (source[key] === undefined) continue;
			if (key === "style") {
				target[key] = assignPropsNotUndefined(target[key], source[key]);
			} else {
				target[key] = source[key];
			}
		}
	}
	return target;
}
/**
 * 
 * @param {*} target 
 * @ignore
 */
let assignArrayStr = function (target) {
	let length = arguments.length;
	for (var i = 1; i < length; i++) {
		var source = arguments[i];
		if (Object.prototype.toString.call(source) !== "[object Array]") continue;
		let sLength = source.length;
		for (let j = 0; j < sLength; j++) {
			let element = source[j];
			if (target.indexOf(element) < 0) {
				target.push(element);
			}
		}
	}
	return target;
}

/**
 * 
 * @param {*} ctl 
 * @ignore
 */
let refFunction = function (ctl) {

	if (!ctl || !ctl.props || !ctl.props.moduleDesc) {
		return;
	}
	// sgiLogger.log("refFunction", ctl.props.moduleDesc.cId);
	// sgiLogger.log("refFunction", ctl.props.moduleDesc.desId);
	let { moduleDesc, objFct } = ctl.props;
	let itemKey = moduleDesc.cId;
	if (!itemKey) {
		return;
	}
	ComponentManager.set(objFct.getUID(), moduleDesc.cId, ctl);
}

/**
 * 
 * @param {*} items 
 * @param {*} foreach 
 * @param {*} childName 
 * @ignore
 */
let itemForEach = function (items = [], foreach, childName = "cldSet") {
	if (!foreach || typeof foreach !== "function") return;
	items.forEach((item, index, arr) => {
		foreach(item, index, arr);
		let cldSet = item[childName];
		if (cldSet && cldSet.length > 0) itemForEach(cldSet, foreach, childName);
	});
}

/**
 * 提供数组操作相关方法
 * @namespace 数组方法集
 * @alias tool.Array
 */
let sgiArray = {
	/**
	 * 根据索引从数组中删除元素
	 * @param {array} array 源数组
	 * @param {number} index 要删除的索引
	 */
	removeIndex: function (array, index) {
		if (!array || array.length == 0) {
			return;
		}
		if (index == undefined || index == null) {
			return;
		}
		array.splice(index, 1);
	},
	/**
	 * 从数组中删除对象（需要引用相同，会删除多个符合的元素）
	 * @param {array} array 源数组
	 * @param {object} obj 要删除的对象
	 */
	remove: function (array, obj) {
		if (!array || array.length == 0) {
			return;
		}
		if (obj == undefined || obj == null) {
			return;
		}
		for (var i = 0; i < array.length; i++) {
			var tmp = array[i];
			if (tmp == obj) {
				array.splice(i--, 1);//删除数组元素，索引会前移，配合自减运算
			}
		}
	},
	/**
	 * 从数组中删除元素（根据属性key与值，会删除多个符合的元素）
	 * @param {object[]} array 源数组
	 * @param {string} key 要删除对象的匹配属性key
	 * @param {object} value 要删除的对象的匹配属性值
	 */
	removeJson: function (array, key, value) {
		if (!array || array.length == 0) {
			return;
		}
		if (!key || !value) {
			return;
		}
		for (var i = 0; i < array.length; i++) {
			var tmp = array[i];
			if (typeof tmp == "object") {
				if (tmp[key] === value) {
					array.splice(i--, 1);//删除数组元素，索引会前移，配合自减运算
				}
			}
		}
	},
	// swapItems: function (arr, index1, index2) {
	//     arr[index1] = arr.splice(index2, 1, arr[index1])[0];
	//     return arr;
	// }

	/**
	 * 数组内元素位置交换
	 * @param {array} arr 源数组
	 * @param {number} index 当前元素/被交换元素索引
	 * @param {number} tindex 交换元素索引
	 */
	swapItems: function (arr, index, tindex) {
		if (index > tindex) {
			arr.splice(tindex, 0, arr[index]);
			arr.splice(index + 1, 1)
		} else {
			arr.splice(tindex + 1, 0, arr[index]);
			arr.splice(index, 1)
		}
	},
	/**
	 * 向源数组中添加元素，obj可为数组，此时会被解构传入
	 * @param {array} arr 源数组
	 * @param {object|array} obj 要添加到源数组中的对象或数组
	 */
	//判断是否是 数组 如果是数组
	pushObj: function (arr, obj) {
		if (!arr || !obj) {
			return;
		}
		if (getType(obj) === 'array') {
			obj.forEach(element => {
				arr.push(element);
			})
		} else {
			arr.push(obj);
		}
	},
	/**
	 * 
	 * @param {*} arr 数组
	 * @param {*} key 排序key
	 * @param {*} sortType true 正序  false倒序
	 */
	sort: function (arr, key, sortType) {
		arr.sort(function (a, b) {
			if (sortType) {
				return a[key] > b[key];
			} else {
				return a[key] < b[key];
			}
		})
	}
}

/**
 * 提供部分常用格式化方法
 * @namespace 格式化方法集
 * @alias tool.Format
 */
let Format = {
	/**
	 * 金额格式化
	 * @param {string} str 要格式化的字符串
	 * @param {number} fixed 保留小数位数
	 * @returns {string} 格式化后的金额字符串
	 */
	amount: function (str, fixed) {
		fixed = (fixed || fixed === 0) ? fixed : 2;
		str = parseFloat(str || "0").toFixed(fixed) + "";
		let dotPos = str.indexOf(".") > -1 ? str.indexOf(".") : str.length;
		let intSum = str.substring(0, dotPos).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分(添加,号)
		let dot = str.substring(str.length, dotPos)//取到小数部分
		return intSum + dot;
	},
	/**
	 * 计算百分比
	 * @param {number|string} num 被除数
	 * @param {number|string} total 总数/除数
	 * @param {number} [fixed=0] 保留小数位数
	 * @param {boolean} [noPerSign=false] 不带百分号%，默认带%
	 * @returns {string} 百分比字符串
	 */
	percent: function (num, total, fixed, noPerSign) {
		fixed = fixed || 0;
		num = parseFloat(num);
		total = parseFloat(total);
		if (isNaN(num) || isNaN(total) || total <= 0) {
			return 0.00.toFixed(fixed) + (noPerSign ? "" : " %");
		}
		return ((num / total) * 100).toFixed(fixed) + (noPerSign ? "" : " %");
	},
}


let setCookie = function (key, val, time) {//设置cookie方法
	if (!key) {
		return;
	}
	if (!val) {
		val = "";
	}
	val = sgiEncrypt.encrypt(val);

	var time = arguments[2] ? arguments[2] : 30;
	var date = new Date(); //获取当前时间
	var expiresDays = time;  //将date设置为n天以后的时间
	date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000); //格式化为cookie识别的时间
	document.cookie = sgiConfig.abb_project + "-" + key + "=" + val + ";expires=" + date.toGMTString() + ";path=/";  //设置cookie
}

let getCookie = function (key) {//获取cookie方法
	/*获取cookie参数*/
	var getCookie = document.cookie.replace(/[ ]/g, "");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
	var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
	var tips;  //声明变量tips
	for (var i = 0; i < arrCookie.length; i++) {   //使用for循环查找cookie中的tips变量
		var arr = arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
		if (sgiConfig.abb_project + "-" + key == arr[0]) {  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
			const filterCookies = ['userId', 'token']
			if(filterCookies.includes(key) && !arr[1]) {
				// console.log('getCookie', key, tips)
				console.log(`getCookie- ${key}: ${tips}`)
				
				tool.popMessage("登录超时，请重新登录", "warning");
				tool.logout();
				return
			}
			tips = arr[1];   //将cookie的值赋给变量tips
			break;   //终止for循环遍历
		}
	}
	if (tips) {
		tips = sgiEncrypt.decrypt(tips);
	}
	return tips;
}

let deleteCookie = function (key) { //删除cookie方法
	var date = new Date(); //获取当前时间
	date.setTime(date.getTime() - 10000); //将date设置为过去的时间
	// sgiLogger.log(date.toGMTString())
	let path = ";path=/";
	document.cookie = sgiConfig.abb_project + "-" + key + "=v; expires =" + date.toGMTString() + path;//设置cookie

}
// 批量删除cookie-根据前缀
let removeCookieByPrefix = function (prefix) {
	if (!prefix) return;
	let preLength = prefix.length;
	var getCookie = document.cookie.replace(/[ ]/g, "");
	var arrCookie = getCookie.split(";");
	for (var i = 0; i < arrCookie.length; i++) {
		var arr = arrCookie[i].split("=");
		let key = arr[0];
		let pre = key.substr(0, preLength);
		if (prefix === pre) {
			document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
			break;
		}
	}
}

let destroyAllModal = () => {
	Modal.destroyAll();
}

export {
	uuid, uuidDate, jsonToStr, isJSON, funStrCheck, HtmlUtil, strToJson, getAP, copyJsonAttr,
	getLeafByPrm, copy, sgiArray, Format, copyArr, getJsonLength, md5, createElement,
	DateOpt, deepCopyAll, assignProps, assignPropsNotUndefined, assignArrayStr, getType,
	itemForEach, setCookie, getCookie, deleteCookie, removeCookieByPrefix, sgiZip, sgiEncrypt, destroyAllModal
}


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCommon/sgiCommon.js